import React from "react";

export default function Pagination({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
  showCountText = true,
  showTotalItems = true,
  compact = false,
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  //  ถ้ามีการเปลี่ยนจำนวนต่อหน้า ให้กลับไปหน้า 1
  const handleItemsPerPageChange = (e) => {
    const newLimit = Number(e.target.value);
    onItemsPerPageChange(newLimit);
    onPageChange(1);
  };

  //  จำกัดจำนวนเลขหน้าที่แสดง (เช่น 5 หน้า)
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = startPage + maxVisiblePages - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  //  สร้าง array ของเลขหน้าเฉพาะช่วง
  const visiblePages = [];
  for (let i = startPage; i <= endPage; i++) visiblePages.push(i);

  return (
    <div
      className={`w-full flex justify-between items-center ${
        compact ? "mt-0 text-[14px]" : "mt-4 text-[16px]"
      }`}
      style={{
        width: "100%",
        minWidth: "100%",
        display: "grid",
        gridTemplateColumns: showCountText ? "1fr auto" : "1fr",
        alignItems: "center",
        gap: "12px",
        boxSizing: "border-box",
      }}
    >
      {/* ข้อความแสดงจำนวน - ซ่อนได้ด้วย showCountText={false} */}
      {showCountText && (
        <div style={{ flex: "1 1 auto", textAlign: "left" }}>
          {showTotalItems && (
            <>
              จำนวนข้อมูลทั้งหมด{" "}
              <span className="text-red-500 font-bold">{totalItems}</span> รายการ |{" "}
            </>
          )}
          แสดง{" "}
          <select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="border border-red-400 bg-red-500 text-white rounded px-2 py-1 mx-1"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>{" "}
          รายการต่อหน้า
        </div>
      )}

      {/* ปุ่ม pagination */}
      <div className="flex items-center gap-2" style={{ marginLeft: "auto", flex: "0 0 auto", justifyContent: "flex-end", justifySelf: "end" }}>
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className={`px-3 py-1 rounded-full ${
            currentPage === 1
              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
              : "bg-gray-300 hover:bg-red-400 text-white"
          }`}
        >
          «
        </button>

        {/* แสดงเฉพาะช่วงเลขหน้า */}
        {visiblePages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-7 h-7 rounded-full text-white ${
              currentPage === page
                ? "bg-red-500"
                : "bg-gray-300 hover:bg-red-400"
            }`}
          >
            {page}
          </button>
        ))}

        {/* ถ้ามีหน้ามากกว่า visible */}
        {endPage < totalPages && (
          <span className="text-gray-500 font-bold px-1">...</span>
        )}

        <button
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className={`px-3 py-1 rounded-full ${
            currentPage === totalPages
              ? "bg-gray-200 text-gray-500 cursor-not-allowed"
              : "bg-gray-300 hover:bg-red-400 text-white"
          }`}
        >
          »
        </button>
      </div>
    </div>
  );
}
